<div class="option" [class.selected]="selected === value">
	<ng-content></ng-content>
</div>
